<template>
  <v-container class="py-10 py-md-13 py-lg-16 px-1 px-sm-3">
    <TitleWidget class="text-center">
      {{ title }}
    </TitleWidget>

    <slot name="after-title" />

    <LoadingWidget v-if="loading" />

    <template v-else>
      <template v-if="items.length">
        <v-row class="my-0 mx-1 mx-sm-n3">
          <template v-for="item in items">
            <slot name="item" :item="item" />
          </template>
        </v-row>

        <v-pagination
          v-if="pagesLength > 1"
          class="mt-10"
          color="secondary"
          v-model="page"
          :length="pagesLength"
        ></v-pagination>
      </template>

      <v-alert v-else class="mt-6" type="info">
        {{ noContentText }}
      </v-alert>
    </template>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import LoadingWidget from "../widgets/LoadingWidget.vue";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    pagesLength: {
      type: Number,
      default: 0,
    },
    noContentText: {
      type: String,
      default: "Nenhum conteúdo adicionado até o momento.",
    },
  },
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
  },
  components: {
    TitleWidget,
    LoadingWidget,
  },
};
</script>
